import { TimeSpan } from "lib/data/transfer";
import { LoginAttempt } from "./LoginAttempt";

export class LockedLoginResult extends LoginAttempt {
	public static readonly $type: string = "LockedLoginResult";
	public readonly $type: string = LockedLoginResult.$type;

	public lockoutTimeRemaining!: TimeSpan;
}
